import React from 'react'
import * as sys from './common'
import Router from './router'
//import './table.css!'

class ColumnHeader extends React.Component {
	onDropdownClick = (e) => {
		const el = $(e.currentTarget.nextElementSibling)
		e.stopPropagation()
		el.toggle()
		$(document).one('click', () => el.hide())
	}

	onDropdownItemClick = (e) => {
		e.stopPropagation()
		$(e.currentTarget).hide()
	}

	onFilterValueChanged = (e) => {
		const { columnFilter } = this.props

		columnFilter.selected = e.currentTarget.value || e.currentTarget.getAttribute('value')
		if (columnFilter.onChanged) {
			columnFilter.onChanged(columnFilter.selected)
		}
		else {
			this.forceUpdate()
		}
	}

	onSelectClick = (e) => {
		e.stopPropagation()
	}

	renderFilterDropdown = (filter) => {
		const { values, selected } = filter
		const null_value = filter.nullValue || 0
		let list
		let label = selected === undefined || selected == null_value ? filter.header : null

		if (Array.isArray(values)) {
			list = []
			for (let item of values) {
				list.push(<li key={item.value}><a href="#" value={item.value} onClick={this.onFilterValueChanged}>{item.label}</a></li>)
				label = label || (item.value == selected ? item.label : null)
			}
		}
		else {
			list = Object.keys(values).map(value => <li key={value}><a href="#" value={value} onClick={this.onFilterValueChanged}>{values[value]}</a></li>)
			label = label || values[selected]
		}
		return (
			<div className="btn-group wide" role="group">
				<button type='button' className="btn btn-transparent dropdown-toggle" onClick={this.onDropdownClick}>
					<span className='font-weight-bold'>
						{label}
					</span>
					<span className="caret"></span>
				</button>
				<ul className="dropdown-menu" onClick={this.onDropdownItemClick}>
					<li><a href="#" value={null_value} onClick={this.onFilterValueChanged}>({__('attrs_all')})</a></li>
					{list}
				</ul>
			</div>
		)
	}

	renderFilterSelect = (filter) => {
		const { values, selected } = filter
		const list = Array.isArray(values)
			? values.map(item => <option key={item.value} value={item.value}>{item.label}</option>)
			: Object.keys(values).map(value => <option key={value} value={value}>{values[value]}</option>)
		const null_value = filter.nullValue || 0

		return (
			<select className='btn-pure wide' onClick={this.onSelectClick} onChange={this.onFilterValueChanged} value={selected || null_value}>
				<option value={null_value} onClick={this.onFilterValueChanged}>({filter.header}: {__('attrs_all')})</option>
				{list}
			</select>
		)
	}

	renderFilter = (c, filter) => {
		if (filter.hasOwnProperty('render')) {
			return filter.render(c)
		}
		return (Array.isArray(filter.values) ? filter.values.length : Object.keys(filter.values).length) > 12
			? this.renderFilterSelect(filter)
			: this.renderFilterDropdown(filter)
	}

	onSort(column) {
		const { meta, data } = this.props
		const name = column.index || column.name

		// verificar se faz reset à ordenação
		if (name == meta.sort && meta.schc > 1) {
			delete meta.sort
			delete meta.asc
			meta.schc = 0 // chc: same column header clicks
		}
		else {
			meta.schc = name == meta.sort ? (meta.schc + 1) : 1
			meta.asc = meta.sort != name || !meta.asc
			meta.sort = name
		}
		meta.page = 1

		// se dados dinamicos
		if (this.props.url) {
			return this.props.fetchData();
		}
		const asc = meta.asc ? -1 : 1;
		const desc = asc == -1 ? 1 : -1;
		const _data = data.sort((a, b) =>
			a[name] == b[name]
				? 0
				: (a[name] < b[name] ? asc : desc)
		)
		this.props.setData({ data: _data });
	}

	render() {
		const { meta, c, columnFilter, rowEditing, renderColumn, colSpan, rowSpan } = this.props
		const cheader = columnFilter
			? this.renderFilter(c, columnFilter)
			: (
				c.header !== undefined
					? (c.header instanceof Object ? c.header : <span dangerouslySetInnerHTML={{ __html: c.header }} style={{ textAlign: c.headerAlign || c.align || null }} />)
					: c.name //  : (c.name ? trans.get('attrs_' + c.name, null, c.name) : '')
			)
		let el_sort = null;
		let onSort = null;
		let ch;
		const style = {
			width: c.width || null
		};

		if (c.name && !rowEditing && (c.sort == undefined || c.sort)) {
			if (meta.sort != undefined) {
				el_sort =
					<em className={
						(c.index || c.name) == meta.sort
							? (!meta.asc ? 'la la-angle-down la-min' : 'la la-angle-up la-min')
							: 'la la-sort la-min'
					}
					/>
			}
			else {
				el_sort = <em className='la la-sort la-min' />;
			}
			onSort = () => this.onSort(c);
		}
		if ((renderColumn && (ch = renderColumn(c)) != null) || (c.renderHeader && (ch = c.renderHeader(c)) != null)) {
			return (
				<th style={style} className={(c.class || '') + (el_sort ? ' sortable' : '')} colSpan={colSpan || null} rowSpan={rowSpan || null} onClick={onSort}>
					{ch}
				</th>
			);
		}
		return (
			<th style={style} className={(c.class || '') + (el_sort ? ' sortable' : '')}
				title={c.headerTitle || null}
				colSpan={colSpan || null}
				rowSpan={rowSpan || null}
				onClick={onSort}
			>
				<div className="fb-header" style={{ justifyContent: c.headerAlign || c.align || null }}>
					{cheader}
					{el_sort}
				</div>
			</th>
		);

	}
}


export default class Table extends sys.Component {
	static settings = {
	};
	constructor(props) {
		super(props);
		this.state = {
			columns: [],
			data: [],
			meta: {
				page: 1,
				item_per_page: props.itemsPerPage || 10,
				schc: 0,
				sort: null,
				asc: null,
			},
			loading: false,
			rowEditing: null,
			rowSel: null,
			selectionMode: false,
			selection: [],
			current_url: null,
			fetchIteration: 0 // Fetch Data Iteration
		};
		this.searchHandler = false;
		this.unmounted = true;
		this.refSearch = React.createRef();
	}

	componentDidMount() {
		this.setState({
			search: this.props.search === undefined ? true : this.props.search,
			pagination: this.props.pagination === undefined ? true : this.props.pagination
		});
		this.id = this.props.id || sys.simpleHash(this.props.url);
		this.unmounted = false;
		if (this.id) {
			const meta = sessionStorage.getItem(this.id);
			if (meta) {
				this.state.meta = JSON.parse(meta);
				if (this.props.itemsPerPage) {
					this.state.meta.item_per_page = this.props.itemsPerPage;
				}
				/*
				const urlParams = new URLSearchParams(window.location.search);
				const inputParam = urlParams.get(this.id);
				this.state.meta.search = inputParam || '';
				*/
			}
		}
		if (this.props.settings) {
			Table.settings[this.id] = this.props.settings;
		}
		else {
			this.loadSettings();
		}
		if (!this.props.url && this.props.data) {
			this.refreshMetaData(this.props.columns, this.props.data);
		}
		this.fetchData(false);
	}

	componentWillUnmount() {
		setTimeout(() => { this.unmounted = true; }, 0);
	}

	componentDidUpdate() {
		if (this.state.loading == 1) {
			// verificar se entretanto o props.url mudou (nao funciona no metodo ComponentDidUpdate)
			this.fetchData(false);
		}
	}

	setSelectionMode(mode, update = true) {
		if (update) {
			this.setState({ selectionMode: mode });
		}
		else {
			this.state.selectionMode = mode;
		}
	}

	getSelection(state = 1) {
		const sel = {};

		(this.state.data || []).forEach((r) => {
			if (r.selected == state) {
				sel[r.id] = state;
			}
		});
		return sel;
	}

	getSearch() {
		return this.state.meta.search || null;
	}

	loadSettings = () => {
		const url = this.getBaseUrl();

		if (!url || Table.settings.hasOwnProperty(url)) {
			return;
		}
		http.get('/system/getTableSettings.json', {
			url: url,
			silent: true
		}, (response, success) => {
			if (success && response.tableSettings) {
				Table.settings[url] = response.tableSettings;
				setTimeout(() => this.forceUpdate());
			}
		});
	}

	refreshMetaData(columns, data, meta) {
		if (data && data.length > 0) {
			if (!this.props.treeGrid) {
				for (let i in data) {
					data[i].meta = {};
				}
				this.state.meta.item_count = data.length;
			}
			else { // treeGrid
				const parents = {};
				let row;
				const child_name = this.props.childName || 'id';

				for (let i in data) {
					row = data[i];

					row.meta = {
						level: 1,
						treed: meta[row[child_name]]
					};
					if (!parents.hasOwnProperty(row[child_name])) {
						parents[row[child_name]] = [];
					}
					if (!parents.hasOwnProperty(row.parent_id)) {
						parents[row.parent_id] = [];
					}
					if (row.parent_id == 0) {
						parents[row.parent_id].push(row);
					}
					else {
						parents[row.parent_id].unshift(row);
					}
				}
				const rows = parents[0] || [];

				data = [];
				// percorrer apenas os pais
				while (rows.length > 0) {
					row = rows.shift();
					row.meta.hasChildren = parents[row[child_name]] && parents[row[child_name]].length > 0;
					data.push(row);
					if (parents[row[child_name]]) {
						parents[row[child_name]].forEach(child => {
							child.meta.parent = row;
							child.meta.level += row.meta.level;
							rows.unshift(child);
						});
						delete parents[row[child_name]];
					}
				}
			}
		}
		for (let i in columns) {
			const column = columns[i];

			switch (column.format) {
				case 'expand':
					this.state.meta.columnExpand = column;
					this.state.meta.columnExpand.width = '22px';

					if (this.props.autoExpand == 'always') {
						for (let i in data) {
							data[i].meta.expanded = true;
						}
						break;
					}
				case 'actions':
					column.width = column.width || '80px';
			}
			if (!column.hasOwnProperty('header') && column.name) {
				column.header = trans.get('attrs_' + column.name, null, column.name);
			}
		}
		return data;
	}

	update() {
		this.fetchData(true);
	}

	static getDerivedStateFromProps(props, state) {
		if (state.current_url != props.url || (props.fetchIteration && props.fetchIteration != state.fetchIteration)) {
			return {
				current_url: props.url,
				loading: 1, // indica que deve forcar fetchData
				fetchIteration: props.fetchIteration
			}
		}
		if (!props.url && props.columns) {
			props.columns.forEach((c) => {
				if (c.header === undefined) {
					c.header = c.name ? trans.get('attrs_' + c.name, null, c.name) : '';
				}
			});
		}
		if (props.data) {
			state.meta.item_count = props.data.length;
			state.pagination = state.meta.item_count > state.meta.item_per_page;
		}
		if (props.rowEditing != state.rowEditing) {
			return {
				rowEditing: props.rowEditing || (props.rowEditing === null ? null : state.rowEditing)
			}
		}
		return null
	}

	printData = () => {
		if (this.props.onBeforePrint && this.props.onBeforePrint(this.state.meta) === false) {
			return
		}
		const columns = this.state.columns
			.filter(column => column.name && (!column.hasOwnProperty('exportable') || column.exportable))
			.map((column, index) => ({ name: column.name, title: column.header }))

		const params = Object.flat(this.state.meta);
		params.print = this.props.exportType || 'excel';
		params.title = this.props.exportTitle || 'hp_file';
		params.columns = JSON.stringify(columns);

		http.get(this.state.current_url, { data: params },
			(response, success) => {
				if (success && response.file) {
					const file = "/cache/" + encodeURIComponent(response.file);
					window.open(file);
				}
			}
		);
	}

	fetchData = (force = true) => {
		const { loading, current_url } = this.state

		if (loading === true) {
			return;
		}
		if (!(force || loading === 1)) {
			return;
		}
		this.setState({ loading: true });
		const meta = !this.props.treeGrid
			? null
			: this.state.data.reduce(
				(obj, d) => {
					if (d.meta.treed) {
						obj[d.id] = d.meta.treed;
					}
					return obj;
				},
				{ item_per_page: 0, search: this.state.meta.search }
			);
		http.get(current_url, { data: meta || Object.flat(this.state.meta), silent: true }, (response) => {
			if (this.unmounted) {
				return;
			}
			if (response.meta === undefined) {
				response.meta = {};
			}
			const { meta } = response
			meta.asc = !meta.asc ? false : (typeof meta.asc == 'string' ? meta.asc == 'asc' || meta.asc == 'true' : JSON.parse(meta.asc));
			// gravar metadados na sessao
			if (this.id) {
				/*
				let new_url = window.location.pathname;

				if (this.state.meta.search) {
					const searchParams = new URLSearchParams(window.location.search);
					searchParams.set(this.id, this.state.meta.search);
					new_url += `?${searchParams.toString()}`;
				}
				else if (window.location.search) {
					new_url += window.location.search;
				}
				window.history.replaceState(null, null, `${new_url}`);
				*/
				sessionStorage.setItem(this.id, JSON.stringify(this.state.meta));
			}
			if (!response.columns) {
				response.columns = this.state.columns || {};
			}
			response.data = this.refreshMetaData(response.columns, response.data || [], meta);
			Object.assign(
				this.state.meta,
				{ item_per_page: 0, item_count: 0 },
				meta
			);
			if (this.props.onDataFetched) {
				this.props.onDataFetched(response.data);
			}
			if (this.props.autoExpand && this.props.autoExpand == response.data.length) {
				this.onExpand(null, response.data[this.props.autoExpand - 1]);
			}
			if (this.state.rowSel && this.props.onRowSelected instanceof Function) {
				this.props.onRowSelected(null);
			}
			if (this.props.store) {
				this.props.store[this.props.name] = response.data
			}
			this.setState({
				columns: response.columns,
				data: response.data,
				rowEditing: null,
				rowSel: null,
				selection: [],
				loading: false
			});
		});
	}

	filterData = () => {
		const { data, searchColumns } = this.props;

		if (!searchColumns) {
			return;
		}
		const { meta } = this.state;

		if (meta.search == '' || data.length == 0) {
			meta.item_count = data.length;
			this.setState({ dataFiltered: data });
			return;
		}
		const has_filter_data = data[0].hasOwnProperty('_filter_data');

		if (!has_filter_data) {
			data.forEach(row => {
				let _filter_data = searchColumns.reduce((_search, c) => !row[c] ? _search : (_search + row[c].toString()), '');
				row._filter_data = _filter_data.normalize();
			});
		}
		const search = meta.search.normalize();
		const dataFiltered = data.filter((row) => search.in(row._filter_data));

		meta.item_count = dataFiltered.length;

		this.setState({ dataFiltered: dataFiltered });
	}

	onSearch = (e) => {
		if (this.searchHandler) {
			clearTimeout(this.searchHandler);
		}
		this.searchHandler = setTimeout(() => {
			this.state.meta.page = 1;
			this.state.meta.search = this.refSearch.current.value;
			if (this.props.url) {
				this.fetchData();
			}
			else {
				this.filterData();
			}
		}, 1000);
	}

	onClearSearch = (e) => {
		this.state.meta.search = '';
		this.refSearch.current.value = '';
		if (this.props.url) {
			this.fetchData();
		}
		else {
			this.filterData();
		}
	}

	onPage(i) {
		this.state.meta.page = i;
		if (this.props.url) {
			this.fetchData();
		}
		else {
			this.forceUpdate();
		}
	}

	onSort(column) {
		const name = column.index || column.name;

		this.state.meta.asc = this.state.meta.sort != name || !this.state.meta.asc;
		this.state.meta.page = 1;
		this.state.meta.sort = name;
		// se dados dinamicos
		if (this.props.url) {
			return this.fetchData();
		}
		const asc = this.state.meta.asc ? -1 : 1;
		const desc = asc == -1 ? 1 : -1;
		const data = this.props.data.sort((a, b) =>
			a[name] == b[name]
				? 0
				: (a[name] < b[name] ? asc : desc)
		);
		this.setState({ data: data });
	}

	editingMode() {
		if (!this.state.rowEditing) {
			return 0;
		}
		return this.state.rowEditing.id ? 1 : 2;
	}

	setRowEdit(row) {
		this.setState({ rowEditing: row });
		if (this.props.rowEditChanged instanceof Function) {
			this.props.rowEditChanged(row);
		}
	}

	onEdit(row, column, e) {
		const { editable, url, loadRowOnEdit } = this.props

		if (editable === false) {
			if (this.props.onDoubleClick) {
				this.props.onDoubleClick(row, column);
			}
			return;
		}
		if (!url && loadRowOnEdit !== false) {
			//mbox.info(trans.get('dev_url_edit_undefined'));
			return;
		}
		if (this.props.onEdit) {
			this.props.onEdit(row);
			return;
		}
		else if (column && column.actions && column.actions.edit && column.actions.edit.url) {
			return;
		}
		if (this.state.rowEditing) {
			mbox.info(trans.get('attrs_editing_mode'));
			return;
		}
		// copia a row para o caso do cancelamento
		if (row.id) {
			if (this.props.loadRowOnEdit === false) {
				this.rowEditingBkup = Object.assign({}, row);
				delete this.rowEditingBkup.meta;
				this.setRowEdit(row);
				return
			}
			http.get(this.props.url, { data: { edtid: row.id } }, (response) => {
				this.rowEditingBkup = Object.assign({}, row, response.data);
				delete this.rowEditingBkup.meta;
				this.validations = response.validation || {};
				this.setRowEdit(row);
			});
			return;
		}
		if (!row.meta) {
			row.meta = {};
		}
		// se row ainda nao existe, significa que é novo
		if (this.state.data.indexOf(row) < 0) {
			this.state.data.unshift(row);
		}
		else if (row.id) {
			this.rowEditingBkup = Object.assign({}, row);
		}
		this.setRowEdit(row);
	}

	onDoubleClick(row, column) {
		if (column.actions.edit.url) {
			Router.go(column.actions.edit.url.replace(':id', row.id));
		}
		else if (this.props.onDoubleClick) {
			this.props.onDoubleClick(row, column);
		}
	}

	onCancel(row) {
		if (this.rowEditingBkup) {
			Object.assign(row, this.rowEditingBkup);
		}
		else {
			const data = this.props.data || this.state.data
			const i = data.indexOf(row)

			if (i >= 0) {
				data.splice(i, 1)
			}
		}
		this.rowEditingBkup = null
		this.setRowEdit(null)
	}

	onSave(row) {
		const { urlSave, loadRowOnEdit, onSaved } = this.props

		if (!urlSave && loadRowOnEdit !== false) {
			//mbox.info(trans.get('dev_url_save_undefined'));
			return;
		}
		if (urlSave) {
			http.post(urlSave, { data: Object.flat(row) },
				(response, success) => {
					if (!success) {
						return;
					}
					if (response.data) {
						Object.assign(row, response.data);
					}
					else if (response.id) {
						row.id = response.id;
					}
					if (onSaved) {
						onSaved(row, response);
					}
					this.rowEditingBkup = null;
					this.setRowEdit(null);
				}
			);
		}
		else if (loadRowOnEdit === false) {
			this.rowEditingBkup = null;
			this.setRowEdit(null);
			if (onSaved) {
				onSaved(row)
			}
		}
	}

	onDelete(row) {
		// tem a certeza que deseja remover este registo...
		if (this.props.onDelete) {
			this.props.onDelete(row);
		}
		else if (this.props.urlDelete) {
			if (!row.id) {
				this.setState({ data: this.state.data.filter((el) => el != row) });
				return;
			}
			mbox.confirmDelete(() => {
				http.post(
					this.props.urlDelete.replace(/(\:\w+)/g, (param) => row[param.slice(1)] || ''),
					{ data: Object.flat(row) },
					(response, success) => {
						if (success) {
							const { onDeleted } = this.props;

							this.setState({ data: this.state.data.filter(el => el.id != row.id) });
							if (onDeleted) {
								onDeleted(row, response);
							}
							mbox.dismiss()
						}
					}
				);
			}, row.description || row.name || row.id.toString(), undefined, row.id);
		}
		else {
			mbox.info('método delete não definido !', trans.get('attrs_delete'));
		}
	}

	formatReorder(column, row) {
		return (
			<em />
		)
	}

	formatAvatar(column, row) {
		if (!row[column.name]) {
			return null
		}
		if (column.zoomed == true) {
			return (
				<div style={{ width: '25px' }}>
					<div className="zoomed">
						<img className='avatar' src={row[column.name]} />
					</div>
				</div>
			)
		}
		return (
			<div>
				<img className='avatar' src={row[column.name]} />
			</div>
		)
	}


	formatImage(column, row) {
		return row[column.name] ? <img className={column.className || 'circular wide'} src={row[column.name]} /> : null;
	}

	formatIcon(column, row) {
		var icon =
			(column.maps instanceof Object)
				? (
					column.maps.hasOwnProperty(row[column.name])
						? column.maps[row[column.name]]
						: (column.maps.hasOwnProperty('%') ? column.maps['%'] : null)
				)
				: row[column.name];

		if (icon) {
			if (typeof icon == 'string') {
				return <i className={'icon ' + icon} />;
			}
			return <i className={'icon ' + icon.value} title={icon.title.startsWith('@') ? row[icon.title.replace('@', '')] : icon.title} />;
		}
		return null;
	}

	formatEdit(column, row, config) {
		const url = column.actions && column.actions.edit && column.actions.edit.url
			? column.actions.edit.url.replace(/\:(\w+)/g, ($1, $2) => row[$2])
			: null;
		const disabled = this.state.rowEditing != null;

		return React.createElement(
			url ? 'a' : 'button', {
			type: 'button',
			title: config.title || trans.get('attrs_edit'),
			href: url,
			className: (config.class || 'btn btn-default') + (disabled ? ' disabled' : ''),
			onClick: disabled ? null : () => this.onEdit(row, column),
			target: config.target || null,
			key: row.id + 'edit'
		},
			<em className={config.icon || 'la la-pencil'}
			/>)
	}

	formatDelete(column, row, config) {
		var disabled = this.state.rowEditing != null;

		return (
			<button type='button'
				title={trans.get('attrs_delete')}
				className={(config.class || 'btn btn-default') + (disabled ? ' disabled' : '')}
				onClick={disabled ? null : () => this.onDelete(row)}
				disabled={disabled}
				key={row.id + 'delete'}
			>
				<em className='la la-trash' />
			</button>
		);
	}

	formatCheckbox(column, row) {
		return (
			<sys.Checkbox
				name={column.name}
				model={row}
				bitwise={column.bitwise}
				disabled={this.props.disabled || (column.editable !== 2 && this.state.rowEditing == null)}
				onClick={this.props.onClickBool ? () => this.props.onClickBool(column, row) : null}
			/>
		);
	}

	formatBool(column, row) {
		return (
			<em className={
				row[column.name] == null
					? (column.nullSymbol || column.falseSymbol || 'la la-time')
					: (row[column.name] == 0 ? (column.falseSymbol || 'la la-time') : (column.trueSymbol || 'la la-check'))
			} />
		);
	}

	onExpand(column, row, e) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		const expanded = row.meta.expanded === undefined ? true : !row.meta.expanded;

		if (this.props.onBeforeRowExpand) {
			const handled = this.props.onBeforeRowExpand(row, expanded);
			if (handled === undefined || handled === true) {
				return;
			}
		}
		row.meta.expanded = expanded;
		this.forceUpdate();
	}

	formatExpand(column, row) {
		if (!row.id || (column.hidden && row[column.hidden] == 0)) {
			return null;
		}

		if (column.enabled && row[column.enabled] == 0) {
			return <em className={'disabled la la-' + (column.iconPlus || 'angle-right')} title={column.title ? trans.getif(column.title, row) : ''} />
		}

		column.class = 'expand';
		row.meta = row.meta ?? {};
		return (
			<a className='expand pointer' title={column.title ? trans.getif(column.title, row) : ''} onClick={() => this.onExpand(column, row)}>
				<em className={'la la-' + (row.meta.expanded ? (column.iconMinus || 'angle-down') : (column.iconPlus || 'angle-right'))} />
			</a>
		);
	}

	// quando se clica para expandir/retrair uma row na arvore
	treeExpand(column, row, e) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		row.meta.treed = row.meta.treed === undefined ? row.id > 0 : !row.meta.treed;
		if (!row.meta.hasChildren && column.url) {
			row.meta.expanded = row.meta.treed;
			if (row.meta.expanded && !row.meta.fn) {
				/*
				System.import(column.url.urlify(null, 'cid')).then( R => {
					if (!this.unmounted) {
						row.meta.fn = R.default;
						this.forceUpdate();
					}
				});
				*/
				return;
			}
		}
		this.forceUpdate();
	}

	formatTree(column, row) {
		if (!row.id) {
			return null;
		}
		if (!row.meta.hasChildren && !column.url) {
			return (
				<p className={'treed level-' + row.meta.level}>
					<i className='expand fa fa-circle-o' />
					{column.icon ? this.formatIcon(column.icon, row) : null}
					<span>{row[column.name]}</span>
				</p>
			);
		}
		return (
			<p className={'treed level-' + row.meta.level}>
				<a onClick={() => this.treeExpand(column, row)}>
					<i className={'expand icon ' + (row.meta.treed ? (column.iconMinus || 'minus') : (column.iconPlus || 'plus'))} />
					{column.icon ? this.formatIcon(column.icon, row) : null}
					<span>{row[column.name]}</span>
				</a>
			</p>
		);
	}


	formatTrans(column, row) {
		return trans.get(row[column.name]);
	}

	formatCombobox(column, row) {
		const value = row[column.name];

		if (column.alias && row.hasOwnProperty(column.alias)) {
			return row[column.alias];
		}
		// indicar registos no array data
		if (!column.k) {
			column.k = {};
			if (column.data) {
				for (let i in column.data) {
					column.k[column.data[i].value] = i;
				}
			}
		}
		return column.k[value] && column.data[column.k[value]] ? column.data[column.k[value]].label : value;
	}

	formatHtml(column, row) {
		return <div dangerouslySetInnerHTML={{ __html: row[column.name] }} />;
	}

	formatBadge(column, row) {
		return <sys.Badge className={row[column.className]} title={row[column.name]} tip={column.tip ? row[column.tip] : null} />;
	}

	formatHour(column, row) {
		if (hp.settings.can_show_minutes) {
			const hours = Math.floor(row[column.name])
			const minutes = Math.round((row[column.name] - hours) * 60)

			return `${hours}:${minutes.toString().padStart(2, '0')}`
		}

		return row[column.name]
	}

	formatLink(column, row, config) {
		// se filtro definido, verificar se todas as condições se verificam
		if (config.filter) {
			for (let cn in config.filter) {
				if (row[cn] != config.filter[cn]) {
					return null;
				}
			}
		}
		const url = (config.url || '#').replace(/\:(\w+)/g, ($1, $2) => row[$2]);
		return (
			<a key={config.name || '_k'} role="button" aria-label={config.ariaLabel ? config.ariaLabel + ' ' + row.evt_start_aria ?? (row.evt_start).replace('<br>', ' ') : null} className={config.classBtn || 'btn btn-default'} target={config.target || '_blank'} href={url}>
				<em className={config.class || 'la la-external-link-alt'} />
			</a>
		);
	}

	formatDefaultActions(column, row) {
		const actions = [];

		for (let i in column.actions) {
			const config = column.actions[i];
			let el = null;

			if (config.fn instanceof Function) {
				el = config.fn(column, row, config);
			}
			else {
				const fn = "format" + (config.type || i).capitalize();

				if (this.props[fn] instanceof Function) {
					el = this.props[fn](column, row, config);
				}
				else if (this[fn] instanceof Function) {
					el = this[fn](column, row, config);
				}
			}
			if (el) {
				//actions.push(<span key={row.id + i}>{el}</span>);
				actions.push(el);
			}
		}
		if (this.props.groupDefaultActions === false) {
			return actions;
		}
		return (
			<div className={this.props.groupDefaultActionsClass || 'btn-group'}>
				{actions}
			</div>
		);
	}

	formatActions(column, row) {
		if (this.props.formatActions) {
			return this.props.formatActions(column, row, this);
		}
		return this.formatDefaultActions(column, row);
	}

	editorCheckbox(col, row) {
		return <sys.Checkbox model={row} name={col.name} autoFocus={row.meta.focused == 1} validations={this.validations} />;
	}

	editorDate(col, row) {
		return <sys.Input type="date" model={row} name={col.name} classNameEl="form-control input-sm hp-input-max-120" />
	}

	editorNumber(col, row) {
		return <sys.Input type="number" model={row} name={col.name} classNameEl="form-control input-sm hp-input-max-120" />
	}

	editorHour(col, row) {
		return <sys.Input type="time" model={row} name={col.name} classNameEl="form-control input-sm hp-input-max-120" />
	}

	editorUrl(col, row) {
		return <sys.Input type="url" model={row} name={col.name} classNameEl="form-control input-sm" />
	}

	editorDropdown(col, row) {
		//return <Select model={row} name={col.name} url={col.url} data={col.data} value={row[col.name]} description={col.header} />;
		return (
			<sys.Dropdown
				model={row}
				name={col.name}
				url={col.url}
				data={col.data}
				value={row[col.name]}
				description={col.header}
			/>
		);
	}

	editorText(col, row) {
		return <sys.Textarea model={row} name={col.name} className="form-control" />;
	}

	clearSelection() {
		this.setState({ rowSel: null });
	}

	onRowClick = (row, e) => {
		if (e.target.closest('input, button, a, select, textarea, label, [role="button"]:not(tr)')) {
			return;
		}
		if (this.props.onRowClick instanceof Function && this.props.onRowClick(row) === false) {
			return;
		}
		if (this.props.multiselect == 1) {
			this.setState({ rowSel: row });
		}
		if (this.props.onRowSelected instanceof Function) {
			if (this.props.onRowSelected(row)) {
				this.forceUpdate();
				return;
			}
		}
		const colsDef = this.props.columns || this.state.columns;

		// verificar se a primeira coluna é expandir. apenas se não houver seleção de texto
		if (window.getSelection().toString() == '' && colsDef.length > 0 && colsDef[0].format == 'expand') {
			row.meta.expanded = !row.meta.expanded;
			this.forceUpdate();
		}
	}

	onCheckAll = (value) => {
		const data = this.props.data || this.state.data;
		if (data.length > 0) {
			const selected = data.at(0) === undefined ? !selection : (data.at(0).selected ? false : true)
			const selection = selected ? [...data] : []

			data.forEach(row => {
				row.selected = selected
			})
			this.setState({
				selection: selection
			})
			if (this.props.onCheck) {
				this.props.onCheck(selection, selected)
			}
		}
	}

	onCheck(row) {
		const { selection } = this.state;
		const i = selection.findIndex(r => r === row);

		if (row.selected) {
			if (i < 0) {
				selection.push(row)
			}
		}
		else if (i >= 0) {
			selection.splice(i, 1)
		}
		this.forceUpdate()
		if (this.props.onCheck) {
			this.props.onCheck(selection, row.selected)
		}
	}

	onNew = () => {
		this.onEdit(this.props.onNew ? this.props.onNew() : {})
	}

	getBaseUrl = () => {
		const url = this.props.url || this.id;

		if (!url) {
			return null;
		}
		return url.split('?')[0];
	}

	getSettings = () => {
		const url = this.getBaseUrl();
		return url && Table.settings.hasOwnProperty(url) ? Table.settings[url] : null;
	}

	saveSettings = () => {
		const url = this.getBaseUrl();

		if (!url) {
			return;
		}
		http.post('/system/saveTableSettings.json', {
			data: {
				settings: Table.settings[url],
				url: url
			},
			silent: true
		}, (response) => {
			if (response.tableSettings) {
				Table.settings[url] = response.tableSettings;
			}
			this.forceUpdate();
		});
	}

	onClickColumnVisible = (e) => {
		const settings = this.getSettings();

		e.stopPropagation();
		if (e.currentTarget.getAttribute('disabled') === '' || !settings) {
			return;
		}
		const name = e.currentTarget.getAttribute('data-item');
		const column_defs = settings.columns;

		if (!column_defs.hasOwnProperty(name)) {
			column_defs[name] = {
				visible: 0
			};
		}
		else {
			column_defs[name].visible = column_defs[name].visible ? 0 : 1;
		}
		this.forceUpdate();
		this.saveSettings();
	}

	onClickColumnReset = (e) => {
		const settings = this.getSettings();

		e.stopPropagation();
		if (settings) {
			settings.columns = {};
			this.saveSettings();
		}
	}

	renderColumnData(col, row) {
		if (this.state.rowEditing == row) {
			if (col.editable || col.editor) {
				const editor = "editor" + (
					col.editor
						? col.editor.capitalize()
						: (col.format ? col.format.capitalize() : '')
				);
				row.meta.focused = !row.meta.focused ? 1 : row.meta.focused + 1;

				if (this.props[editor] instanceof Function) {
					return this.props[editor](col, row);
				}
				else if (this[editor] instanceof Function) {
					return this[editor](col, row);
				}
				let title = row.meta && row.meta.hasOwnProperty(col.name + '@title') ? row.meta[col.name + '@title'] : '';
				return <sys.Input model={row} name={col.name} className='form-control input-sm' autoFocus={row.meta.focused == 1} title={title} validations={this.validations} />;
			}
			else if (col.actions) {
				return (
					<div className={this.props.groupDefaultActionsClass || 'btn-group'}>
						<button type='button' className='btn btn-default btn-circular' title={__('buttons_cancel')} onClick={() => this.onCancel(row)}>
							<em className='la la-undo' />
						</button>
						<button type='button' className='btn btn-primary btn-circular' title={__('buttons_save')} onClick={() => this.onSave(row)}>
							<em className='la la-check' />
						</button>
					</div>
				);
			}
		}
		if (!col.format) {
			return row[col.name];
		}
		const formatFunc = 'format' + col.format.capitalize();

		if (this.props[formatFunc] instanceof Function) {
			return this.props[formatFunc](col, row);
		}
		return this[formatFunc] instanceof Function
			? this[formatFunc](col, row)
			: row[col.name];
	}

	setData = (data) => {
		this.setState({ data: data });
	}

	render() {
		const { props, state } = this
		const rowEditing = state.rowEditing || props.rowEditing
		const colsDef = props.columns || state.columns
		const loader = state.loading === true
			? [<sys.Loader key='l' className='inline' />, <div key='o' className='overlay' />]
			: null;

		const settings = this.getSettings();
		let data = state.dataFiltered || props.data || state.data;
		let rows = [];
		const header = [];
		let footer = [];
		let cActions = null;
		const meta = state.meta;
		const column_defs = settings ? settings.columns : null;
		let column_configs = [];
		const columns_props = {};
		const columns_order = [];
		const columns2 = [];

		colsDef.forEach((c, i) => {
			const visible = !column_defs || !column_defs.hasOwnProperty(c.name) ? 1 : column_defs[c.name].visible;
			const disabled = false; //c.visible === undefined;

			// se a coluna está definida para não aparecer a qualquer user
			if (visible == -1) {
				return;
			}
			if (c.actions) {
				cActions = c;
			}
			if (c.name) {
				let header = c.helperTitle || c.header || c.headerTitle || c.name;

				header = (header instanceof Object) ? header : <span dangerouslySetInnerHTML={{ __html: header }} />;
				column_configs.push(
					<li key={i}>
						<a className={classNames('toggle flex wide py-1', !disabled ? 'pointer' : 'disabled')} data-item={c.name} onClick={this.onClickColumnVisible}>
							<span className={disabled ? 'disabled' : null}>{header}</span>
							<em className={classNames('ml-a', visible ? 'la la-toggle-on' : 'la la-toggle-off', disabled ? 'disabled' : null)} />
						</a>
					</li>
				);
			}
			if (!visible) {
				return;
			}
			const column_props = {
				key: 'th-' + i,
				c: c,
				meta: meta,
				data: data,
				url: props.url,
				fetchData: this.fetchData,
				setData: this.setData,
				rowEditing: rowEditing,
				columnFilter: props.columnFilters && props.columnFilters.hasOwnProperty(c.name) ? props.columnFilters[c.name] : null,
			};

			// verificar se coluna pertence a um grupo
			if (c.group) {
				columns2.push(React.createElement(ColumnHeader, column_props));
				if (columns_props.hasOwnProperty(c.group)) {
					columns_props[c.group].colSpan += 1;
				}
				else {
					columns_props[c.group] = {
						tag: 'th',
						key: 'th-' + i,
						className: 'header',
						colSpan: 1
					};
					columns_order.push(c.group);
				}
			}
			else {
				column_props.rowSpan = props.columnGroups ? 2 : null;
				columns_props[c.name || `_${i}`] = column_props;
				columns_order.push(c.name || `_${i}`);
			}
		})
		const columns = columns_order.map((name) => (
			React.createElement(columns_props[name].tag || ColumnHeader, columns_props[name], props.columnGroups && props.columnGroups.hasOwnProperty(name) ? props.columnGroups[name].header : null)
		));
		const paginate = meta && state.pagination && !this.props.treeGrid;
		const ddn_id = `ddn_${this.id}`;

		column_configs = column_configs.length == 0 ? null :
			<div className='btn-group'>
				<button type='button' className="btn btn-xs btn-transparent btn-circular dropdown-toggle" id={ddn_id} data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
					<em className="la la-ellipsis-v" />
				</button>
				<ul className="dropdown-menu w-med" aria-labelledby={ddn_id}>
					<li className="dropdown-header">{__('attrs_columns_def')}</li>
					{column_configs}
					<li role="divider" className="divider" />
					<li>
						<a className='pointer' onClick={this.onClickColumnReset}>
							<em className='ml-a la la-redo-alt' />
							<span>{__('buttons_reset_configs')}</span>
						</a>
					</li>
				</ul>
			</div>;

		if (!this.props.url && paginate) {
			const k = ((meta.page || 1) - 1) * meta.item_per_page;
			data = data.slice(k, k + meta.item_per_page);
		}
		if (!rowEditing && (state.selectionMode || this.props.selectionMode)) {
			columns.unshift(
				<th key={'th-k'} className='selection' width="22px" rowSpan={columns2.length > 0 ? 2 : null}>
					<sys.Checkbox
						onClick={this.onCheckAll}
						checked={state.selection.length > 0}
					/>
				</th>
			);
		}
		if (this.props.renderRow) {
			rows = data.map(d => this.props.renderRow(d, colsDef));
		}
		else {
			// filtrar dados em caso de treegrid
			if (this.props.treeGrid) {
				data = data.filter(d => {
					for (let p = d.meta.parent; p; p = p.meta.parent) {
						if (!p.meta.treed)
							return false;
					}
					return true;
				});
			}
			let k = 0;
			rows = data.map((d, i) => {
				const columnData = [];

				colsDef.forEach((c, j) => {
					if (column_defs && column_defs.hasOwnProperty(c.name) && column_defs[c.name].visible <= 0) {
						return;
					}
					const style = {
						textAlign: c.align || null
					};
					const content = this.renderColumnData(c, d);
					const title =
						d.title || (
							c.title
								? (c.title.startsWith('#') ? d[c.title.substring(1)] : trans.getif(c.title, d))
								: null
						);
					columnData.push(
						React.createElement(c.el || 'td', {
							key: 'td-' + (k++),
							title: title,
							className: c.class,
							style: style
						}, content
						)
					);
				});
				if (!rowEditing && (state.selectionMode || this.props.selectionMode)) {
					columnData.unshift(
						<td key={'td-k' + i} className='selection'>
							<sys.Checkbox
								name='selected'
								model={d}
								onClick={(e) => this.onCheck(d, e)}
							/>
						</td>
					);
				}
				if (!d.meta) {
					d.meta = {};
				}
				d.meta.focused = 0;
				let props = this.props.getRowProps instanceof Function
					? this.props.getRowProps(d, columnData)
					: null;
				if (colsDef[0].format == 'expand') {
					props = props || {};
					props.className = classNames(props.className, 'pointer');
				}
				if (!d.meta.expanded) {
					return (
						<tr key={'r' + i}
							onDoubleClick={
								cActions && cActions.actions.edit
									? (e) => this.onDoubleClick(d, cActions, e)
									: (rowEditing ? null : (e) => this.onEdit(d, cActions, e))
							}
							onClick={(e) => this.onRowClick(d, e)}
							{...props}
							className={classNames(state.rowSel == d ? 'selected' : null, (props ? props.className : null))}
						>
							{columnData}
						</tr>
					)
				}
				return [
					<tr key={i + 'xo'} className='expanded-owner' onClick={(e) => this.onRowClick(d, e)} {...props}>{columnData}</tr>,
					<tr key={i + 'x_'} />,
					<tr key={i + 'xx'} className='expanded'>
						<td />
						<td colSpan={!rowEditing && (state.selectionMode || this.props.selectionMode) ? colsDef.length : colsDef.length - 1} className='content'>
							{this.props.renderRowExpanded ? this.props.renderRowExpanded(d) : null}
						</td>
					</tr>
				];
			});
		}
		// paginacao
		const pagination = [];

		if (paginate && rowEditing == null) {
			const pages = meta.item_per_page ? Math.ceil(Number(meta.item_count) / Number(meta.item_per_page)) : 0;

			if (meta.page > 1) {
				pagination.push(
					<button key='first' className='btn btn-transparent' onClick={() => this.onPage(1)} title={__('buttons_first')}>
						<em className='la la-angle-double-left' />
					</button>
				);
				pagination.push(
					<button key='prev' className='btn btn-transparent' onClick={() => this.onPage(Number(meta.page) - 1)}>
						<em className='la la-angle-left' />
					</button>
				);
			}
			if (meta.page < pages) {
				pagination.push(
					<button key='next' className='btn btn-transparent' title={__('buttons_next')} onClick={() => this.onPage(Number(meta.page) + 1)}>
						<em className='la la-angle-right' />
					</button>
				);
				pagination.push(
					<button key='last' className='btn btn-transparent' onClick={() => this.onPage(pages)} title={__('buttons_last')}>
						<em className='la la-angle-double-right' />
					</button>
				);
			}
			if (pagination.length > 0) {
				footer.push(
					<div key='p' className='ml-a flex-center'>
						{<div className='pr-1'>{meta.page} de {pages}</div>}
						<div className='flex-group btn-group-circular'>{pagination}</div>
					</div>
				);
			}
		}

		if (state.search) {
			const { toolbar, searchTip } = this.props;

			header.push(
				<div className='header flex-center' key='h1'>
					{column_configs}
					<div className='search'>
						<em className="la la-info-circle" title={searchTip || __('tips_search_words_applied_to_multiple_columns')} />
						<input
							type='search'
							ref={this.refSearch}
							defaultValue={meta.search}
							className='search'
							placeholder={trans.get('attrs_search')}
							onChange={this.onSearch}
							disabled={rowEditing != null}
							autoFocus={this.props.autoFocus}
						/>
						{meta.search
							? <a
								onClick={this.onClearSearch}
								disabled={rowEditing != null || meta.search == '' || meta.search == undefined}
								title={trans.get('attrs_clear_search')}
							>
								<em className="la la-close la-min" />
							</a>
							: null
						}
					</div>
					<div className="btn-group-circular flex-group ml-a">
						{toolbar instanceof Array
							? toolbar
							: (toolbar && toolbar.items && toolbar.align == 'left' ? toolbar.items : null)
						}
						{this.props.newLabel && !rowEditing
							? <button type='button' className="btn btn-primary btn-xs" onClick={this.onNew}>
								<em className="la la-plus" />
								<span>{this.props.newLabel}</span>
							</button>
							: null
						}
						{(!this.props.hasOwnProperty('export') || this.props.export)
							? <button
								className='btn btn-transparent'
								onClick={this.printData}
								disabled={rowEditing != null}
								title={trans.get('buttons_print')}
							>
								<em className='la la-print' />
							</button>
							: null
						}
						{(this.props.showRefreshBtn === undefined || this.props.showRefreshBtn) && this.props.url
							? <button
								className='btn btn-transparent'
								onClick={this.fetchData}
								disabled={rowEditing != null}
								title={trans.get('buttons_update')}
							>
								<em className='la la-sync' />
							</button>
							: null
						}
						{toolbar instanceof Object && toolbar.items && toolbar.align == 'right' ? toolbar.items : null}
						{pagination}
					</div>
				</div>
			);
			column_configs = null;
		}
		else if (!this.props.title && column_configs && !colsDef[0].header) {
			const positionLeft = this.props.selectionMode ? '24px' : '5px';
			column_configs =
				<div style={{ position: 'absolute', top: '5px', left: positionLeft, zIndex: 11 }}>
					{column_configs}
				</div>;
		}
		if (this.props.title) {
			header.unshift(
				<div key='h0' className='titled flex-center'>
					{column_configs}
					<div>{this.props.title}</div>
				</div>
			);
			column_configs = null;
		}
		if (footer.length > 0) {
			footer =
				<div className='flex-center px-1 py-1'>
					{footer}
				</div>;
		}
		return (
			<div className={"table-container " + (this.props.classNameContainer || '')}>
				{loader}
				{header}
				<div className={this.props.classNameTableContainer || null}>
					{column_configs}
					<table
						className={(this.props.className || 'table regular_table') + ' ' + (this.props.name || '') + (this.props.multiselect == 1 ? ' multi' : '')}
					>
						{columns
							? <thead>
								<tr>{columns}</tr>
								{columns2.length > 0 ? <tr>{columns2}</tr> : null}
							</thead>
							: null
						}
						<tbody>{rows}</tbody>
					</table>
				</div>
				{footer}
				{data.length == 0 && this.props.emptyMessage
					? <div className='alert-none center'>{this.props.emptyMessage}</div>
					: null
				}
			</div>
		);
	}
}
